import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Paper,
  Typography,
  Avatar,
  Box,
  Chip,
  Button,
  Divider,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { motion } from 'framer-motion';
import { AuthContext } from '../auth/AuthContext';
import { StatsContext } from '../stats/StatsContext';
import {
  AiOutlineEye,
  AiOutlineFileText,
  // AiOutlineWarning,
  AiOutlineSolution,
  // AiOutlineCalendar,
  AiOutlineUser,
  AiOutlineUserAdd,
  AiOutlineStar,
  AiOutlineCheckCircle,
  // AiOutlinePlus,
} from 'react-icons/ai';
import {FaUserCheck} from 'react-icons/fa'
import DashboardStats from '../stats/DashboardStats';
// import Swal from 'sweetalert2';

const getTimeOfDay = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Morning';
  if (hour < 18) return 'Afternoon';
  return 'Evening';
};



const sectionStyle = {
  borderLeft: '6px solid #228B22',
  borderRadius: '12px',
  padding: '16px',
  backgroundColor: '#f0fdf4',
  boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
};

const cardStyle = {
  padding: '20px',
  borderRadius: '12px',
  backgroundColor: '#fff',
  boxShadow: '0 3px 12px rgba(34,139,34,0.15)',
  transition: 'transform 0.2s ease-in-out',
};

const Dashboard = () => {
  const { currentUser } = useContext(AuthContext);
  const { stats, fetchStats } = useContext(StatsContext)
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const counts = {
    // myReports: 3,
    // newReports: 2,
    // allIssues: 5,
    // assignedIssues: 1,
    // myIssues: 4,
    // upcomingEvents: 2,
    // recentEvents: 1,
    // reviews: 3,
    // verifyReviews: 2,
  };

useEffect(() => {
  const timeout = setTimeout(() => {
    if (!currentUser) {
      navigate('/login');
    }else{
      fetchStats()
    }
  }, 180000); // 3 minutes = 180000 milliseconds

  return () => clearTimeout(timeout); // Cleanup on unmount
}, []);

  const groupedSections = [
    {
      title: 'Reports & Issues',
      cards: [
        {
          title: 'My Reports',
          description: `You have Submitted ${stats?.my_reports?.total || 0} reports.`,
          icon: '📄',
          route: '/reports/all', rank: 1,
          role: ['all'],
        },
        {
          title: 'Pending Reports',
          description: 'Recently submitted reports.',
          icon: '📄', badge: stats?.tagged_issues?.pending_reports || 0,
          route: '/reports/pending', rank: 2,
          role: ['admin'],
        },
        { 
          title: 'All Reported Issues',
          description: `Browse all ${stats?.all_issues?.total } reported issues.`,
          icon: '⚠️',
          route: '/issues', rank: 3,
          role: ['all'],
        },
        {
          title: 'My Tasks',
          description: `You have ${ stats?.tasked_issues?.pending || 0 } Pending  and ${ stats?.tasked_issues?.in_progress || 0 } In-Progress issues tasked to you.`,
          icon: '✅ ', badge: (stats?.tasked_issues?.pending + stats?.tasked_issues?.in_progress) || 0,
          route: '/issues/assigned', rank: 4,
          role: ['admin', 'specialist'],
        },
        {
          title: 'Tagged Reports',
          description: 'Issues Tagged you to oversee it resolution.',
          icon: <FaUserCheck />, badge: (stats?.tagged_issues?.pending + stats?.tagged_issues?.in_progress) || 0,
          route: '/my-issues', rank: 5,
          role: ['admin'],
        },
        {
          title: 'Latest Proposals (Pending)',
          description: 'Proposed Solutions for issues tagged to you for Approval or Request Revision.',
          icon: <AiOutlineSolution />, badge: stats?.tagged_issues?.proposals,
          route: '/issues/solutions', rank: 6,
          role: ['admin'],
        },
      ],
    },
    // {
    //   title: 'Events & Actions',
    //   cards: [
    //     {
    //       title: 'Upcoming Events',
    //       description: 'Check all scheduled events.',
    //       icon: <AiOutlineCalendar />, badge: counts.upcomingEvents,
    //       route: '/events', rank: 3,
    //       role: ['all'],
    //     },
    //     {
    //       title: 'My Participations',
    //       description: 'Your past event participations.',
    //       icon: <AiOutlineCheckCircle />,
    //       route: '/events/my-participations', rank: 4,
    //       role: ['all'],
    //     },
    //     {
    //       title: 'Add Event',
    //       description: 'Organize a new environmental event.',
    //       icon: <AiOutlinePlus />,
    //       route: '/events/add', rank: 1,
    //       role: ['admin', 'specialist', 'support'],
    //     },
    //     {
    //       title: 'My Events',
    //       description: 'These are the Events that organized by you.',
    //       icon: <AiOutlinePlus />,
    //       route: '/events/my-events', rank: 2,
    //       role: ['admin', 'specialist', 'support'],
    //     },
    //   ],
    // },
    {
      title: 'Community & Reviews',
      cards: [
        {
          title: 'All Reviews',
          description: 'View reviews by community members.',
          icon: <AiOutlineStar />,
          route: '/reviews', rank: 1,
          role: ['all'],
        },
        {
          title: 'My Reviews',
          description: "Check all the reviews you've made.",
          icon: <AiOutlineCheckCircle />, badge: stats?.my_reviews?.total || 0,
          route: '/my-reviews', rank: 2,
          role: ['all'],
        },
      ],
    },
    {
      title: 'Profile & Management',
      cards: [
        {
          title: 'My Profile',
          description: 'View or edit your profile.',
          icon: <AiOutlineUser />,
          route: '/profile', rank: 1,
          role: ['all'],
        },
        {
          title: 'Change Password',
          description: 'View or edit your Account Password.',
          icon: '🔐',
          route: '/password/change', rank: 2,
          role: ['all'],
        },
        {
          title: 'Authorities',
          description: 'View Support, Authorities and Specialists.',
          icon: <AiOutlineUserAdd />,
          route: '/admin-users', rank: 3,
          role: ['admin', 'support'],
        },
      ],
    },
    {
      title: 'Support & Contact',
      cards: [
        {
          title: 'Contact Support',
          description: 'Contact support here if you have any questions, issues or concerns .',
          icon: <AiOutlineUser />,
          route: '/contact/form', rank: 1,
          role: ['all'],
        },
        {
          title: 'Handle Contact Submissions',
          description: `You have ${stats?.contacts?.new } new contact submissions.`,
          icon: <AiOutlineFileText />, badge: stats?.contacts?.new || 0,
          route: '/contact', rank: 2,
          role: ['support'],
        },
        {
          title: 'User Management',
          description: 'Manage All User accounts.',
          icon: <AiOutlineUserAdd />,
          route: '/users/management', rank: 3,
          role: ['support'],
        },
      ],
    },
  ];
  // console.log(stats)

  return (
    <Box p={isMobile ? 2 : 4} textAlign={'center'} bgcolor="rgb(240, 253, 244,0.75)">
      <Box mb={4}>
        <Typography variant="h5" fontWeight="bold" color="#228B22">
          Good {getTimeOfDay()}, {currentUser?.name} 
        </Typography>
        <Typography color="text.secondary">
          Welcome to your MazGuard Dashboard.Tracking reports, issues and community contributions
        </Typography>
      </Box>
        <DashboardStats stats={stats} />
      

      {groupedSections.map((section, i) => {
        const visibleCards = section.cards.filter(card =>
          card.role.includes('all') || card.role.includes(currentUser?.role)
        );
        if (visibleCards.length === 0) return null;
        return (
          <Box mb={5} key={i} sx={sectionStyle}>
            <Typography variant="h6" gutterBottom fontWeight={600} color="forestgreen">
              {section.title}
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Grid container spacing={3}>
              {visibleCards
                .sort((a, b) => a.rank - b.rank)
                .map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <motion.div whileHover={{ scale: 1.02 }}>
                      <Paper elevation={3} sx={cardStyle}>
                        <Stack spacing={2}>
                          <Box display="flex" alignItems="center" gap={2}>
                            <Avatar sx={{ bgcolor: '#228B22' }}>{card.icon}</Avatar>
                            <Box>
                              <Typography fontWeight={600}>{card.title}</Typography>
                              <Typography variant="body2" color="text.secondary">
                                {card.description}
                              </Typography>
                            </Box>
                            {card.badge > 0 && (
                              <Chip label={card.badge} color="info" sx={{ ml: 'auto' }} />
                            )}
                          </Box>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => navigate(card.route)}
                            sx={{ alignSelf: 'flex-start', textTransform: 'none', borderColor: '#228B22', color: '#228B22' }}
                            startIcon={<AiOutlineEye />}
                          >
                            View
                          </Button>
                        </Stack>
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
            </Grid>
          </Box>
        );
      })}
    </Box>
  );
};

export default Dashboard;